<script setup lang="ts">
import type { User } from '~/types'

import { useStore } from '~/store'

import Token from '~/ui/Token.vue'
import { to } from '~/routing'

// TODO: Check uses and simplify

interface Props {
  user: User
  avatar?: boolean
  solid?: true
}

const store = useStore()

const props = withDefaults(defineProps<Props>(), {
  avatar: true
})
</script>

<template>
  <Token
    v-if="props.user"
    v-bind="to({
      name: 'profile.content',
      params: { username: props.user.username }
    })"
    class="color-default-solid"
    >
    <template #image>
      <img
        v-if="props.avatar && props.user.avatar"
        v-lazy="store.getters['instance/absoluteUrl'](props.user.avatar.urls.small_square_crop)"
        :alt="props.user.username"
      >
      <Icon
        v-else
        icon="bi:person-circle"
      />
    </template>
    {{ props.user.username }}
  </Token>
</template>
